<template>
    <div class="dashboard-chart-card mr-1">
        <div class="d-flex justify-content-center mb-3 mt-3 pt-3 pb-3" v-if="is_load">
            <b-spinner variant="success" label="Loading..."></b-spinner>
        </div>

        <div class="chart" v-else>
            <highcharts :options="chartOptions" :highcharts="char3d"></highcharts>
        </div>
    </div>
</template>

<script>

import {Chart} from 'highcharts-vue'
import Highcharts3D from 'highcharts/highcharts-3d'
import Highcharts from 'highcharts'
Highcharts3D(Highcharts)
export default {

    name: "all_orders",
    components: {
        highcharts: Chart
    },

    created () {
        console.log(Highcharts.getOptions().colors[3]);
    },
    mounted() {
        this.getStat();
    },

    data() {
        return {
            is_load: true,
            char3d: Highcharts,
            chartOptions : {
                title: {
                    text: this.__t('LAST_6_MONTH_SALES'),
                    align: 'left',
                    style: {
                        color: '#3b3f5c',
                        fontSize: '15px',
                        fontWeight: '600',
                    }
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    categories: ['Jet fuel', 'Duty-free diesel', 'Petrol', 'Diesel', 'Gas oil'],
                    lineColor: '#eef0f5'
                },
                yAxis: [
                    {
                        title: {
                            text: this.__t('ORDER_COUNT')
                        },
                        gridLineColor: '#f1f2f7'
                    },
                    {
                        title: {
                            text: this.__t('P.INCOME')
                        },
                        opposite: true,
                        gridLineWidth: 0,
                    },
                ],
                tooltip: {
                    pointFormat: '<span style="color:{series.color}">●</span> {series.name}: <b>{point.y} {series.userOptions.unit}</b><br/>'
                },
                plotOptions: {
                    series: {
                        borderRadius: '4%'
                    }
                },
                series: [

                ]


            }
        }
    },
    methods: {
        async getStat() {
            this.is_load = true;
            await api.post('/internal/v1/catalog/dashboard/orders/year', {
                'dashboard_type': 'year',
            }).then(({data}) => {

                if (data.status == "operation_success") {
                    let res = data.data;
                    if(res.hasOwnProperty("categs")) {
                        this.chartOptions.xAxis.categories = res.categs;
                    }

                    if(res.hasOwnProperty('series')) {
                        this.chartOptions.series = res.series;
                    }

                    //this.chartOptions.series[0].data = data.data.series;
                    //  console.log('bank_serias',data.data.series);
                    this.is_load = false;
                }

            }).catch(err => {
                this.is_load = true;
                console.log(err);
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });


        }
    },

    computed: {
        dash_param_date() {
            return this.$store.state.dashboard.main.date;
        },

    },
}
</script>

<style scoped>

</style>
